"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var syncMemoryHost_exports = {};
__export(syncMemoryHost_exports, {
  createMemorySyncFactory: () => createMemorySyncFactory
});
module.exports = __toCommonJS(syncMemoryHost_exports);
function createMemorySyncFactory() {
  var states = /* @__PURE__ */ new Map();
  var nextId = 1;
  return {
    create(initial) {
      var id = nextId++;
      var state = {
        value: initial,
        onChange: null
      };
      states.set(id, state);
      var released = function released2() {
        if (!states.has(id)) throw new Error("OneNativeSyncState was released");
      };
      return {
        id,
        get: function get() {
          released();
          return state.value;
        },
        set: function set(next) {
          var _state_onChange;
          released();
          state.value = next;
          (_state_onChange = state.onChange) === null || _state_onChange === void 0 ? void 0 : _state_onChange.call(state, next);
        },
        setOnChange: function setOnChange(listener) {
          state.onChange = listener !== null && listener !== void 0 ? listener : null;
        },
        release: function release() {
          states.delete(id);
        }
      };
    }
  };
}
//# sourceMappingURL=syncMemoryHost.js.map
